"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Chip = exports.AuChips = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _reactIntl = require("react-intl");
var _constants = require("../../constants");
var _reactChips = _interopRequireDefault(require("./react-chips"));
var _AuTooltip = _interopRequireDefault(require("./AuTooltip"));
var _context2, _context3, _context4, _context5, _context6, _context7, _context8;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "au_chips-module__container___j2lfU",
  "chip": "au_chips-module__chip___GfOcP",
  "valid": "au_chips-module__valid___al9iL au_chips-module__chip___GfOcP",
  "new": "au_chips-module__new___o1xpw",
  "glow": "au_chips-module__glow____nWEx",
  "invalid": "au_chips-module__invalid___PvSRw au_chips-module__chip___GfOcP",
  "remove": "au_chips-module__remove___EysHi",
  "selected": "au_chips-module__selected___dsI4u",
  "text": "au_chips-module__text___vjesU",
  "edit": "au_chips-module__edit___WoVt0",
  "input": "au_chips-module__input___AvCNZ",
  "disabled": "au_chips-module__disabled___slErC"
}; // AuChip Renders Chips.js, which render Chip.js by default in the renderChip
// function, but we override renderChip to render Chip with is an intl wrapped SmallChip
class SmallChip extends _react.default.PureComponent {
  static propTypes = {
    uniqueParentId: T.string.isRequired,
    index: T.number,
    editIndex: T.number,
    className: T.string,
    children: T.any,
    isNew: T.bool,
    errors: T.array,
    selected: T.bool,
    onClick: T.func,
    onBlur: T.func,
    onRemove: T.func,
    intl: T.shape({
      formatMessage: T.func.isRequired
    }).isRequired
  };
  static defaultProps = {
    onClick: _constants.NOOP,
    onBlur: _constants.NOOP,
    onRemove: _constants.NOOP
  };
  render() {
    // index, selected and onRemove are passed by default from Chips
    const {
      intl,
      uniqueParentId,
      className,
      children,
      isNew,
      index,
      editIndex,
      errors,
      selected,
      onClick,
      onBlur,
      onRemove
    } = this.props;
    const error = errors && errors[index];
    const classNames = (0, _classnames.default)({
      [styles.valid]: !error,
      [styles.invalid]: error,
      [styles.selected]: selected,
      [styles.new]: !error && isNew
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classNames,
      "data-tip": true,
      "data-for": `${uniqueParentId}_chip-${index}`,
      onClick: e => onClick(index, e)
    }, error && /*#__PURE__*/_react.default.createElement(_AuTooltip.default, {
      type: "error",
      id: `${uniqueParentId}_chip-${index}`,
      title: intl.formatMessage({
        id: error.errTitleId || error.errDisplayId
      }, (0, _values.default)(error))
    }, error.errDisplayId && error.errTitleId && intl.formatMessage({
      id: error.errDisplayId
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.text,
      title: children
    }, children), index === editIndex && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.edit
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      autoFocus: true,
      className: styles.input,
      defaultValue: children,
      onBlur: e => onBlur(index, e),
      onKeyDown: e => {
        var _context;
        if ((0, _includes.default)(_context = [_constants.TAB_KEY, _constants.ENTER_KEY]).call(_context, e.key)) {
          onBlur(index, e);
        }
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.remove,
      onClick: e => {
        e.stopPropagation();
        onRemove(index);
      }
    }));
  }
}
const Chip = exports.Chip = (0, _reactIntl.injectIntl)(SmallChip);
class AuChips extends _react.default.Component {
  static propTypes = {
    chips: T.array,
    disabled: T.bool,
    storedChips: T.object,
    errors: T.array,
    className: T.string,
    createChipKeys: T.arrayOf(T.string),
    suggestions: T.array,
    uniqueChips: T.bool,
    placeholder: T.string,
    placeholderId: T.string,
    fromSuggestionsOnly: T.bool,
    highlightFirstSuggestion: T.bool,
    handleOnPaste: T.bool,
    handleOnBlur: T.bool,
    onChange: T.func,
    intl: T.shape({
      formatMessage: T.func.isRequired
    }).isRequired
  };
  static defaultProps = {
    chips: [],
    storedChips: {},
    uniqueChips: false,
    fromSuggestionsOnly: false,
    createChipKeys: [_constants.ENTER_KEY],
    suggestions: [],
    // TBD
    handleOnPaste: false,
    handleOnBlur: false,
    onChange: _constants.NOOP
  };
  state = {
    editIndex: -1
  };

  // uniqueId is passed to child chips to distinguish them between multiple
  // instances
  _uniqueId = (0, _uniqueId.default)('chips-');
  setChipsRef = (0, _bind.default)(_context2 = this.setChipsRef).call(_context2, this);
  setChipsRef(chips) {
    const {
      handleOnPaste,
      handleOnBlur
    } = this.props;
    if (chips?.wrapperRef?.current) {
      this.chipsEl = chips.wrapperRef.current;
      this.inputEl = this.chipsEl.querySelector('input');
    }
    if (this.chipsEl) {
      this.chipsEl.addEventListener('mouseup', this.onMouseUp);
    }
    if (handleOnPaste && this.inputEl) {
      this.inputEl.addEventListener('paste', this.onPaste);
    }
    if (handleOnBlur && this.inputEl) {
      this.inputEl.addEventListener('blur', this.onPaste);
    }
  }
  componentWillUnmount() {
    const {
      handleOnPaste,
      handleOnBlur
    } = this.props;
    if (this.inputEl) {
      this.inputEl.removeEventListener('mouseup', this.onMouseUp);
    }
    if (handleOnPaste && this.inputEl) {
      this.inputEl.removeEventListener('paste', this.onPaste);
    }
    if (handleOnBlur && this.inputEl) {
      this.inputEl.removeEventListener('blur', this.onPaste);
    }
  }
  onChange = (0, _bind.default)(_context3 = this.onChange).call(_context3, this);
  onChange(val) {
    this.props.onChange(val);
    if (this.chipsEl && val.length > this.props.chips.length) {
      (0, _setTimeout2.default)(() => {
        this.chipsEl.scrollTop = this.chipsEl.scrollHeight;
      });
    }
  }
  onMouseUp = (0, _bind.default)(_context4 = this.onMouseUp).call(_context4, this);
  onMouseUp(e) {
    if (this.inputEl && e.target === this.chipsEl) {
      const top = this.chipsEl.scrollTop;
      // NOTE: Safari doesn't support `preventScroll`
      this.inputEl.focus({
        preventScroll: true
      });
      // fallback for Safari
      this.chipsEl.scrollTop = top;
    }
  }
  onPaste = (0, _bind.default)(_context5 = this.onPaste).call(_context5, this);
  onPaste() {
    // Trigger Enter key pressed event
    const event = new KeyboardEvent('keydown', {
      bubbles: true,
      cancelable: true,
      key: _constants.ENTER_KEY,
      code: _constants.ENTER_KEY
    });
    (0, _setTimeout2.default)(() => this.inputEl.dispatchEvent(event));
  }
  handleOnClick = (0, _bind.default)(_context6 = this.handleOnClick).call(_context6, this);
  handleOnClick(editIndex) {
    this.setState({
      editIndex
    });
  }
  handleOnBlur = (0, _bind.default)(_context7 = this.handleOnBlur).call(_context7, this);
  handleOnBlur(index, e) {
    const chips = [...this.props.chips];
    (0, _splice.default)(chips).call(chips, index, 1, e.target.value);
    this.onChange(chips);
    this.setState({
      editIndex: -1
    });
  }
  renderChip = (0, _bind.default)(_context8 = this.renderChip).call(_context8, this);
  renderChip(value) {
    const {
      editIndex
    } = this.state;
    const stored = (value in this.props.storedChips);
    return /*#__PURE__*/_react.default.createElement(Chip, {
      isNew: !stored,
      editIndex: editIndex,
      onClick: this.handleOnClick,
      onBlur: this.handleOnBlur,
      errors: this.props.errors,
      uniqueParentId: this._uniqueId
    }, value);
  }
  render() {
    const {
      intl,
      disabled,
      className,
      placeholder,
      placeholderId,
      chips,
      uniqueChips,
      suggestions,
      handleOnPaste,
      fromSuggestionsOnly,
      highlightFirstSuggestion
    } = this.props;
    const createChipKeys = [...this.props.createChipKeys];

    // onPaste event won't work without `Enter` key code being tracked
    if (handleOnPaste && !(0, _includes.default)(createChipKeys).call(createChipKeys, _constants.ENTER_KEY)) {
      /* eslint-disable no-console */
      console.info(`AuChips: KeyCode "${_constants.ENTER_KEY}" added to createChipKeys in order to handle "paste" events`);
      /* eslint-enable no-console */
      createChipKeys.push(_constants.ENTER_KEY);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, {
        [styles.disabled]: disabled
      }, className)
    }, /*#__PURE__*/_react.default.createElement(_reactChips.default, {
      ref: this.setChipsRef,
      uniqueChips: uniqueChips,
      value: chips,
      renderChip: this.renderChip,
      onChange: this.onChange,
      createChipKeys: createChipKeys,
      fromSuggestionsOnly: fromSuggestionsOnly,
      highlightFirstSuggestion: highlightFirstSuggestion,
      placeholder: placeholderId ? intl.formatMessage({
        id: placeholderId
      }) : placeholder || '',
      suggestions: suggestions
    }));
  }
}
exports.AuChips = AuChips;
var _default = exports.default = (0, _reactIntl.injectIntl)(AuChips);